import { mapState } from 'vuex'
import commonUtils from './commonUtils'
import { MessageBox } from 'element-ui'
import io from 'socket.io-client/dist/socket.io.slim.js'
import SessionInfo from '@/views/chat/components/SessionInfo'
import CountTimer from '@/views/chat/components/CountTimer'
import AgentTable from '@/views/watch/components/AgentTable'
// import DevModule from 'dev-module'
const components = { SessionInfo, CountTimer, AgentTable }

export default {
  name: 'watch',
  components: components,
  data() {
    return {
      session_tab: ['坐席列表'],
      session_tab_active: 0,
      blankPage: true,
      dialogBox: false,
      loading: false,
      msg_tips_show: false,
      timeMap: new Map(),
      current_user: {
        sessionId: '',
        userId: '',
        agentId: '',
        // type: '',
        body: {
          sessionId: '',
          agentId: '',
          skillGroupId: '',
          nickname: '',
          platform: '',
          chatHistories: [],
          category: 'single',
          type: 'p',
          time: '',
          supAgentsMap: new Map()
        },
        draft: '',
        isEvaluated: false,
        msgCount: 0,
        msgPredict: '',
        sessionInfo: {
          cached: false,
          inited: false,
          sessTime: '00:00',
          evaluate: 0,
          firstResTime: '',
          avgResTime: '',
          bizName: '-',
          pageName: '-',
          channelName: '-',
          numOfPeople: 0
        }
      },
      resourceDownloadPath: window.$envUtils('VUE_APP_BASE_URL') + window.$envUtils('VUE_APP_WB_SERVICE') + '/res/download',
      blacklistForm: {
        unbanTime: '',
        banMessage: ''
      },
      addBlacklistItemDialog: false,
      pickerDisabled: {
        disabledDate: (time) => {
          return time.getTime() < new Date(new Date().toLocaleDateString()).getTime()
        }
      },
      huihuajieshuFlag: false,
      msgIds: [] // 收到消息的id，过滤重复消息
    }
  },
  computed: {
    ...mapState([
      'user', 'emojis'
    ]),
    curSessionInfo() {
      return this.current_user.sessionInfo
    },
    curJoinAgent() {
      return this.current_user.body.supAgents
    }
  },
  watch: {
    current_user() {
      // this.handleClick(this.current_user.userId)
    }
  },

  created() {
    this.createSocket()
  },

  mounted() {
    this.$refs.list1.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    this.$socket.emit('activeDisconnect', null)
    this.$refs.list1.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    // 到达对话框最底部
    toBottom() {
      this.$refs.list1.scrollTop = this.$refs.list1.scrollHeight
    },

    // 对话框滚动条事件处理
    handleScroll() {
      var scrollTop = this.$refs.list1.scrollTop
      if (scrollTop + this.$refs.list1.clientHeight >= this.$refs.list1.scrollHeight - 5) {
        this.msg_tips_show = false
      }

      // 如果滚动条移动到了最顶部，并且当前访客【历史会话】个数 > 0 ，则去获取【上一个历史会话】中的【聊天记录集】，渲染到页面中
      if (scrollTop === 0 && this.current_user.body.sessionIds && this.current_user.body.sessionIds.length > 0) {
        // 获取上一个历史会话，所以此处需要先+1
        this.current_user.body.sessionIndex++
        // 如果+1后发现已经遍历到结尾了，则不再继续查询
        if (this.current_user.body.sessionIndex < this.current_user.body.sessionIds.length) {
          // 否则根据下标，提取出【上一个历史会话id】，向后端查询该【历史会话id】对应的所有【聊天记录集】，渲染到页面中
          const params = { sessionId: this.current_user.body.sessionIds[this.current_user.body.sessionIndex] }
          this.getChatHistories(params)
        }
      }
    },

    // 获取最近的聊天记录
    async getNewChatHistories() {
      const params = { userId: this.current_user.userId }
      const res1 = await this.$http.get(window.$envUtils('VUE_APP_BP_SERVICE') + '/data/session_log/get', { params })
      this.current_user.body.sessionIds = res1.data.data.map(sessionLog => { return sessionLog.sessionId })

      const params1 = {
        userId: this.current_user.userId,
        currentSessionId: this.current_user.sessionId,
        currentAgentId: this.current_user.chiefAgentId
      }
      const res2 = await this.$http.get(window.$envUtils('VUE_APP_BP_SERVICE') + '/data/chat_log/getForScrollbar', { params: params1 })
      res2.data.data.chatLogs.forEach(item => {
        const chatHistories = {
          d: item.direction,
          t: item.createTime,
          type: item.type,
          agent: {
            name: item.agent.name
          },
          msg: item.msgContent,
          messageId: item.messageId
        }
        this.current_user.body.chatHistories.push(chatHistories)
      })
      this.current_user.body.sessionIndex = res2.data.data.scrollInitialIndex
    },

    // 获取历史聊天记录
    getChatHistories(params) {
      this.loading = true
      var currentHeight = this.$refs.list1.scrollHeight
      this.$http.get(window.$envUtils('VUE_APP_BP_SERVICE') + '/data/chat_log/get', { params }).then(res => {
        const chatHistories = res.data.data.map(item => {
          return {
            d: item.direction,
            t: item.createTime,
            type: item.type,
            agent: {
              name: item.agent.name
            },
            msg: item.msgContent,
            messageId: item.messageId
          }
        })
        this.current_user.body.chatHistories.unshift(...chatHistories)
        setTimeout(() => {
          this.$refs.list1.scrollTop = this.$refs.list1.scrollHeight - currentHeight
          this.loading = false
        }, 300)
      })
    },

    // 转义消息中的表情、图片、文件和换行符
    translateMessage(type, body) {
      if (type === 'image') {
        return '<img style="max-width:150px" src="' + this.resourceDownloadPath + body.url + '"/>'
      } else if (type === 'file') {
        return '<div style="min-width:200px;float:left"><img style="max-width:60px;float:left" src="./static/image/file.png"><a target="hide_iframe" href="' + this.resourceDownloadPath + body.url + '"><div style="margin-top:8px;padding-top:5px;text-decoration:underline;color:black">' + (body.name.length > 15 ? body.name.substring(0, 15) + '...' : body.name) + '</div></a><div style="color:black">大小：' + body.size + '</div></div>'
      } else if (type === 'video') {
        return '<div><video style="width:100%" controls="controls" src="' + this.resourceDownloadPath + body.url + '"></video></div>'
      } else if (type === 'text') {
        body.content = body.content.replace('\n', '<br />')
        if (/\[.*?\]/g.test(body.content) || /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g.test(body.content)) {
          var emojis = this.emojis.emojis
          for (let i = 0; i < emojis.length; i++) {
            body.content = body.content.replace(emojis[i].reg, '<img src="./static/emoji/' + emojis[i].file + '"  alt="" style="vertical-align: middle; width: 24px; height: 24px" />')
          }
        }
        return body.content
      }
    },

    // 收到消息
    receiveMsg(me, type, data) {
      if (data.sessionId === this.current_user.sessionId) {
        this.receiveMsgShow(data, type)
      }
    },

    // 收到消息后更新会话时长，并且渲染前端
    receiveMsgShow(data, type) {
      const chatHistory = {
        d: data.direction,
        t: commonUtils.getNowFormatDate().trim(),
        type: type,
        agent: {
          name: this.current_user.body.supAgentsMap.get(data.msgSenderId) ? this.current_user.body.supAgentsMap.get(data.msgSenderId).name : this.user.userInfo.nickname,
          avatar: this.current_user.body.supAgentsMap.get(data.msgSenderId) ? this.current_user.body.supAgentsMap.get(data.msgSenderId).avatar : this.user.userInfo.avatar
        },
        msg: data.body
      }
      this.current_user.body.chatHistories.push(chatHistory)
      if (data.direction === 'down') {
        this.current_user.body.userNoReplyMsgTime = '0'
        this.renderWaitTime()
      } else if (data.direction === 'up') {
        if (this.current_user.body.userNoReplyMsgTime === '0') {
          this.renderWaitTime()
        }
        this.current_user.body.userNoReplyMsgTime = new Date().getTime()
      }
      this.current_user.msgPredict = '' // 关闭消息预测框
      if (this.$refs.list1.scrollTop + this.$refs.list1.clientHeight < this.$refs.list1.scrollHeight - 10) {
        this.msg_tips_show = true
      } else {
        setTimeout(() => {
          this.$refs.list1.scrollTop = this.$refs.list1.scrollHeight
        }, 0)
      }
    },

    // 初始化会话信息
    getSessionInfo(session_) {
      this.huihuajieshuFlag = false
      this.current_user.body.chatHistories = [] // 清空之前的聊天记录
      const sessionId = session_.sessionId
      const userId = session_.userId
      const agentId = session_.agentId

      this.current_user.sessionId = sessionId
      this.current_user.userId = userId
      this.current_user.agentId = agentId

      // 弹出对话框
      this.blankPage = false
      this.dialogBox = true

      this.watchSession()

      this.$http.get(window.$envUtils('VUE_APP_WB_SERVICE') + '/infinite/currentSession/sessionInfo/' + sessionId).then(res => {
        if (res.data.code === 500) {
          this.$message(res.data.message)
          this.blankPage = true
          this.dialogBox = false
          return
        }
        const map = res.data.data
        const supAgents_ = map.supAgents
        const session = map.sessionInfo
        this.current_user.chiefAgentId = session.chiefAgentId
        // this.$refs.sessionInfoRef.initSessionInfo(session, map.supAgents)
        this.current_user.sessionInfo = session
        session.finalSessTime = 0
        this.getNewChatHistories()
        supAgents_.forEach(agent => {
          this.current_user.body.supAgentsMap.set(agent.id, {
            id: agent.id,
            name: agent.name,
            avatar: agent.avatar
          })
        })
        this.current_user.body.supAgents = [...supAgents_]
      })
    },

    // 监听会话
    watchSession() {
      const message = {
        sessionId: this.current_user.sessionId,
        userId: '',
        agentId: this.user.userInfo.id,
        tenantId: localStorage.getItem('X-TENANT-ID'),
        type: 'watch',
        body: {
          sessionId: this.current_user.sessionId,
          watcherId: this.user.userInfo.id
        }
      }
      this.$socket.emit('watch', message)
    },

    sendMsgConfirmBack(data) {
      const params = {
        type: 'mack',
        messageId: data.messageId,
        sessionId: data.sessionId || null,
        timestamp: new Date().getTime(),
        agentId: this.user.userInfo.id || '',
        userId: data.userId || ''
      }
      this.$socket.emit('message', params)
      if (!(data.messageId && data.retryTimes && this.msgIds.includes(data.messageId))) {
        if (data.messageId) {
          // 缓存收到的messageID,用于判断重发的消息是否被处理过
          this.msgIds.push(data.messageId)
          if (this.msgIds.length > 300) {
            this.msgIds.splice(0, 100)
          }
        }
        return false
      } else {
        return true
      }
    },

    // 创建socket连接
    createSocket() {
      this.$socket = io.connect(window.$envUtils('VUE_APP_SOCKET_BASE_URL') + 'im/agent?agentId=' + this.$store.state.user.userInfo.id + '&tenantId=' + (localStorage.getItem('X-TENANT-ID') ? localStorage.getItem('X-TENANT-ID') : '') + '&mode=watch&status=' + localStorage.getItem('WORK-STATUS'), {
        forceNew: true
      })
      this.watchSocketEvent()
    },

    // 监听相关事件
    watchSocketEvent() {
      var me = this
      // 监听socket连接事件
      this.$socket.on('connect', function (data) {
      })

      // 监听用户上线事件
      this.$socket.on('online', function (data) {
        const isRepeatMsg = me.sendMsgConfirmBack(data)
        if (isRepeatMsg) {
          return
        }
        data.body.chatHistories = []
        if (data.body.direction !== 'up') {
          data.body.userNoReplyMsgTime = '0'
        }
        data.body.supAgentsMap = new Map()
        data.body.supAgents.forEach(agent => {
          data.body.supAgentsMap.set(agent.id, {
            id: agent.id,
            name: agent.name,
            avatar: agent.avatar
          })
        })
        data.sessionInfo = {}
        me.current_user = data
        me.renderWaitTime() // 重新启动客户等待时间的定时器
      })

      // 监听用户离线事件
      this.$socket.on('offline', function (data) {
        const isRepeatMsg = me.sendMsgConfirmBack(data)
        if (isRepeatMsg) {
          return
        }
        if (data.sessionId === me.current_user.sessionId) {
          me.current_user.sessionInfo = Object.assign({}, me.current_user.sessionInfo, { finalSessTime: new Date().getTime() - new Date(Date.parse(me.current_user.body.time.replace(/-/g, '/'))).getTime() })
          me.current_user.body.userNoReplyMsgTime = '0'
          me.huihuajieshuFlag = true
        }
      })

      // 监听文本消息事件
      this.$socket.on('text', function (data) {
        const isRepeatMsg = me.sendMsgConfirmBack(data)
        if (isRepeatMsg) {
          return
        }
        me.receiveMsg(me, 'text', data)
      })

      this.$socket.on('image', function (data) {
        const isRepeatMsg = me.sendMsgConfirmBack(data)
        if (isRepeatMsg) {
          return
        }
        me.receiveMsg(me, 'image', data)
      })

      this.$socket.on('file', function (data) {
        const isRepeatMsg = me.sendMsgConfirmBack(data)
        if (isRepeatMsg) {
          return
        }
        me.receiveMsg(me, 'file', data)
      })

      // 监听系统提示事件
      this.$socket.on('tips', function (data, ackServerCallback) {
        const isRepeatMsg = me.sendMsgConfirmBack(data)
        if (isRepeatMsg) {
          return
        }
        if (data.sessionId === me.current_user.sessionId) {
          const chatHistory = {
            d: 'system',
            t: commonUtils.getNowFormatDate().trim(),
            type: 'text',
            msg: {
              content: data.body.content
            }
          }
          me.current_user.body.chatHistories.push(chatHistory)
          if (ackServerCallback) {
            const ack = {
              type: 'ack'
            }
            ackServerCallback(ack)
          }
        }
      })

      // 监听会话信息刷新事件
      this.$socket.on('refresh', function(data) {
        const isRepeatMsg = me.sendMsgConfirmBack(data)
        if (isRepeatMsg) {
          return
        }
        if (data.sessionId === me.current_user.sessionId) {
          Object.assign(me.current_user.sessionInfo, data.body)
        }
      })

      // 监听主管坐席加入会话的事件
      this.$socket.on('join', function(data) {
        const isRepeatMsg = me.sendMsgConfirmBack(data)
        if (isRepeatMsg) {
          return
        }
        me.current_user.body.supAgentsMap.set(data.body.watcherId, {
          id: data.body.watcherId,
          name: data.body.watcherName,
          avatar: data.body.avatar
        })
        me.current_user.body.category = 'multi'
        me.current_user.body.supAgents = [...me.current_user.body.supAgentsMap.values()]
        me.current_user.sessionInfo.numOfPeople = me.current_user.sessionInfo.numOfPeople + 1
        // me.$refs.sessionInfoRef.refreshSessionInfo({
        //   numOfPeople: me.current_user.sessionInfo.numOfPeople,
        //   supAgents: [...me.current_user.body.supAgentsMap.values()]
        // })
      })

      // 监听其他坐席退出会话事件
      this.$socket.on('leave', function(data) {
        const isRepeatMsg = me.sendMsgConfirmBack(data)
        if (isRepeatMsg) {
          return
        }
        me.$notify({
          title: '退出会话',
          duration: 6000,
          message: '坐席 ' + data.body.leaverName + ' 退出了会话'
        })
        me.current_user.body.supAgentsMap.delete(data.body.leaverId)
        me.current_user.body.supAgents = [...me.current_user.body.supAgentsMap.values()]
        me.current_user.sessionInfo.numOfPeople = me.current_user.sessionInfo.numOfPeople - 1
        // me.$refs.sessionInfoRef.refreshSessionInfo({
        //   numOfPeople: me.current_user.sessionInfo.numOfPeople,
        //   supAgents: [...me.current_user.body.supAgentsMap.values()]
        // })
      })

      // 监听满意度评价事件
      this.$socket.on('evaluate', function(data) {
        const isRepeatMsg = me.sendMsgConfirmBack(data)
        if (isRepeatMsg) {
          return
        }
        if (data.sessionId === me.current_user.sessionId) {
          const chatHistory = {
            d: 'system',
            t: commonUtils.getNowFormatDate().trim(),
            type: 'evaluate',
            msg: {
              content: data.body.fb ? '用户已评价了本次会话' : '客服发起了一次服务评价'
            }
          }
          me.current_user.body.chatHistories.push(chatHistory)
          if (data.body.fb) {
            me.current_user.sessionInfo.evaluate = data.body.rate
            // me.$refs.sessionInfoRef.refreshSessionInfo({ evaluate: data.body.rate })
          }
        }
      })

      // 监听消息预测事件
      this.$socket.on('typing', function (data) {
        const isRepeatMsg = me.sendMsgConfirmBack(data)
        if (isRepeatMsg) {
          return
        }
        if (data.sessionId === me.current_user.sessionId) {
          clearTimeout(me.timeMap.get(data.userId + 'typing'))
          me.current_user.msgPredict = '访客正在输入：' + data.body.content
          const t = setTimeout(() => {
            me.current_user.msgPredict = ''
          }, 5000)
          me.timeMap.set(data.userId + 'typing', t)
        }
      })
      // 不重连
      this.$socket.on('duplicate', function (data) {
        const isRepeatMsg = me.sendMsgConfirmBack(data)
        if (isRepeatMsg) {
          return
        }
        me.$message.error({
          message: '该网站重复打开，连接已断开，请前往新打开网站监控或刷新重新连接',
          duration: 15000
        })
        me.$socket.close()
      })
    },

    // 计算用户等待时间
    renderWaitTime() {
      if (this.current_user.body.userNoReplyMsgTime > '0') {
        this.$refs.waitTimer.restartTimer(new Date().getTime() - this.current_user.body.userNoReplyMsgTime)
      } else {
        this.$refs.waitTimer.restartTimer(0)
      }
    },

    // 加入会话
    joinSession() {
      this.$router.push({
        name: 'workbench.sidebar_chat',
        params: {
          source: 'watch',
          sessionId: this.current_user.sessionId
        }
      })
      this.$socket.emit('activeDisconnect', null)
    },

    // 将用户加入黑名单
    /* addBlockList() {
      MessageBox.confirm(
        '是否将该用户加入黑名单?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }
      ).then(() => {
        const data = { visitorId: this.current_user.userId, platformIds: [''] }
        this.$http.post(window.$envUtils('VUE_APP_BP_SERVICE') + '/customBlacklist/infinite/addItem', { data }).then(res => {
          const message = {
            sessionId: this.current_user.sessionId,
            userId: this.current_user.userId,
            agentId: this.user.userInfo.id,
            type: 'finish',
            body: {
              type: 2
            }
          }
          this.$socket.emit('finish', message)
        })
      }).catch(() => {})
    }, */

    // 结束会话
    finishSession() {
      MessageBox.confirm(
        '是否结束该会话?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }
      ).then(() => {
        const message = {
          sessionId: this.current_user.sessionId,
          userId: this.current_user.userId,
          agentId: this.user.userInfo.id,
          tenantId: localStorage.getItem('X-TENANT-ID'),
          type: 'finish',
          body: {
            type: 2
          }
        }
        this.$socket.emit('finish', message)
      }).catch(() => {})
    },
    // 将用户加入黑名单
    addBlockList() {
      this.openAddBlacklistItemDialog()
      /* MessageBox.confirm(
        '是否将该用户加入黑名单?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }
      ).then(() => {
        const data = { visitorId: this.current_user.userId, platformIds: [''] }
        this.$http.post(window.$envUtils('VUE_APP_BP_SERVICE') + '/customBlacklist/infinite/addItem', { data }).then(res => {
        })
      }).catch(() => {}) */
    },
    addNewBlacklistItem() {
      const data = {
        visitorId: this.current_user.userId,
        platformIds: [''],
        sessionId: this.current_user.sessionId,
        ...this.blacklistForm
      }
      this.$http.post(window.$envUtils('VUE_APP_BP_SERVICE') + '/customBlacklist/infinite/addItem', { data }).then(res => {
        if (res.data.code === 2000) {
          this.$message.success('添加成功!')
          this.closeAddBlacklistItemDialog()
          const message = {
            sessionId: this.current_user.sessionId,
            userId: this.current_user.userId,
            agentId: this.user.userInfo.id,
            tenantId: localStorage.getItem('X-TENANT-ID'),
            type: 'finish',
            body: {
              type: 2
            }
          }
          this.$socket.emit('finish', message)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    closeAddBlacklistItemDialog() {
      this.addBlacklistItemDialog = false
      this.clearAddBlacklistItem()
    },
    openAddBlacklistItemDialog() {
      this.addBlacklistItemDialog = true
    },
    clearAddBlacklistItem() {
      this.blacklistForm.unbanTime = ''
      this.blacklistForm.banMessage = ''
    }
  }
}
